import { SentryClient } from '~/lib/sentry.client';

export type SafeJsonParseOptions = {
  /** @default true. Set false when invalid JSON is expected (e.g. SSE). */
  captureParseErrors?: boolean;
};

export function safeJsonParse<T>(
  jsonString: string,
  fallback: T,
  options?: SafeJsonParseOptions
): T {
  const captureParseErrors = options?.captureParseErrors ?? true;
  if (!jsonString) {
    return fallback;
  }
  try {
    return JSON.parse(jsonString) as T;
  } catch (err) {
    if (captureParseErrors && typeof window !== 'undefined') {
      SentryClient.captureException(err);
    }
    return fallback;
  }
}
